<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    :to="{
                        name: 'home',
                    }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">#PastiCuan Telkomsel</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->

            <!-- List Operator -->
            <div class="section mt-2">
                <!-- Style Operator "LIST" -->
                <div class="transactions">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        class="item"
                        style="padding: 10px"
                        @click="openTelkomselOmni()"
                    >
                        <div class="detail">
                            <img
                                v-lazyload
                                :src="require('@/assets/tsel.png')"
                                alt="image"
                                class="image-block imaged"
                                style="width: 30px"
                            />
                            <div style="color: #17273e">
                                <b>Telkomsel Omni</b>
                                <footer>
                                    <small
                                        >Paket Data sesuai dengan nomor yang
                                        akan disikan</small
                                    >
                                </footer>
                            </div>
                        </div>

                        <div class="right">
                            <div class="icon">
                                <ion-icon
                                    name="chevron-forward-outline"
                                ></ion-icon>
                            </div>
                        </div>
                    </a>
                    <!-- * item -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import $axios from './../../../../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loading: {
                    content: false,
                },
            };
        },
        created() {
            // this.getOperator();
            // // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV', 'device']),
        },
        methods: {
            openTelkomselOmni() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openTelkomselOmni();
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Fitur ini hanya bisa digunakan diperangkat Android, silahkan download aplikasi di Playstore',
                        tipe: 'default',
                        icon: 'warning',
                    });
                }
            },
            getPaymentCode(paymentCode) {
                this.$store.commit('SET_TOAST', {
                    show: true,
                    message: 'Kode Bayar : ' + paymentCode,
                    tipe: 'default',
                    icon: 'success',
                });
            },
            selectProduct(data) {
                this.$router.push({
                    name: 'pascabayar-order',
                    params: {
                        id: data.id, // product id
                        product_selected: data, // product detail
                    },
                });
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);
            window['getPaymentCode'] = paymentCode => {
                this.getPaymentCode(paymentCode);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
